export { default as ImagePanel } from './ImagePanel';



// WEBPACK FOOTER //
// ./src/components/ImagePanel/index.js